import { useEffect } from 'react';
import { connect } from 'react-redux';

import LinkTypeEnum from 'redpoints-model-js/enumeration/LinkTypeEnum';

import { Notification } from 'redpoints-front-components/index';

import {
  getAreContentLinksProcessed,
  getAreDetectionLinksProcessed,
  getLinksManagementLinksProcessedContentLinksFailured,
  getLinksManagementLinksProcessedContentLinksSuccessfully,
  getLinksManagementLinksProcessedDetectionLinksFailured,
  getLinksManagementLinksProcessedDetectionLinksSuccessfully,
  getLinksManagementLinksProcessingContentLinks,
  getLinksManagementLinksProcessingDetectionLinks,
  getLinksManagementRelaunchEnforcementErrorLinksCount,
  getLinksManagementRelaunchEnforcementSuccessfulLinksCount,
} from '../../../reducers/tasks/linksManagement';
import { translate } from '../../../helpers/languageHelper';

const showLinksProcessedMessage = (
  linkType,
  successfulLinksCount,
  failedLinksCount
) => {
  if (linkType === LinkTypeEnum.DETECTION.name) {
    if (failedLinksCount) {
      Notification.error({
        message: translate(
          'tasks.links_management.messages.detection_links_processed_failured'
        ).replace('[linkNumber]', failedLinksCount),
      });
    } else if (successfulLinksCount) {
      Notification.success({
        message: translate(
          'tasks.links_management.messages.detection_links_processed_successfully'
        ).replace('[linkNumber]', successfulLinksCount),
      });
    }
  } else if (linkType === LinkTypeEnum.CONTENT.name) {
    if (failedLinksCount) {
      Notification.error({
        message: translate(
          'tasks.links_management.messages.content_links_processed_failured'
        ).replace('[linkNumber]', failedLinksCount),
      });
    } else if (successfulLinksCount) {
      Notification.success({
        message: translate(
          'tasks.links_management.messages.content_links_processed_successfully'
        ).replace('[linkNumber]', successfulLinksCount),
      });
    }
  }
};

const LinksManagementMessages = ({
  areContentLinksProcessed,
  areDetectionLinksProcessed,
  cleanLinks,
  contentLinks,
  contentLinksFailured,
  contentLinksSuccessfully,
  detectionLinks,
  detectionLinksFailured,
  detectionLinksSuccessfully,
  relaunchEnforcementErrorLinksCount,
  relaunchEnforcementSuccessfulLinksCount,
}) => {
  useEffect(() => {
    if (detectionLinks.length > 0 && areDetectionLinksProcessed) {
      showLinksProcessedMessage(
        LinkTypeEnum.DETECTION.name,
        detectionLinksSuccessfully,
        detectionLinksFailured
      );
    }
  }, [
    areDetectionLinksProcessed,
    detectionLinks,
    detectionLinksFailured,
    detectionLinksSuccessfully,
  ]);

  useEffect(() => {
    if (contentLinks.length > 0 && areContentLinksProcessed) {
      showLinksProcessedMessage(
        LinkTypeEnum.CONTENT.name,
        contentLinksSuccessfully,
        contentLinksFailured
      );
    }
  }, [
    areContentLinksProcessed,
    contentLinks,
    contentLinksFailured,
    contentLinksSuccessfully,
  ]);

  useEffect(() => {
    const zeroFailedLinks = 0;
    const zeroSuccessfulLinks = 0;

    if (
      relaunchEnforcementSuccessfulLinksCount &&
      !relaunchEnforcementErrorLinksCount
    ) {
      showLinksProcessedMessage(
        LinkTypeEnum.DETECTION.name,
        relaunchEnforcementSuccessfulLinksCount.DETECTION,
        zeroFailedLinks
      );

      showLinksProcessedMessage(
        LinkTypeEnum.CONTENT.name,
        relaunchEnforcementSuccessfulLinksCount.CONTENT,
        zeroFailedLinks
      );
      cleanLinks();
    }

    if (
      relaunchEnforcementErrorLinksCount &&
      !relaunchEnforcementSuccessfulLinksCount
    ) {
      showLinksProcessedMessage(
        LinkTypeEnum.DETECTION.name,
        zeroSuccessfulLinks,
        relaunchEnforcementErrorLinksCount.DETECTION
      );

      showLinksProcessedMessage(
        LinkTypeEnum.CONTENT.name,
        zeroSuccessfulLinks,
        relaunchEnforcementErrorLinksCount.CONTENT
      );
    }
  }, [
    cleanLinks,
    relaunchEnforcementErrorLinksCount,
    relaunchEnforcementSuccessfulLinksCount,
  ]);

  return null;
};

const mapStateToProps = state => {
  return {
    areContentLinksProcessed: getAreContentLinksProcessed(state),
    areDetectionLinksProcessed: getAreDetectionLinksProcessed(state),
    contentLinks: getLinksManagementLinksProcessingContentLinks(state),
    contentLinksFailured: getLinksManagementLinksProcessedContentLinksFailured(
      state
    ),
    contentLinksSuccessfully: getLinksManagementLinksProcessedContentLinksSuccessfully(
      state
    ),
    detectionLinks: getLinksManagementLinksProcessingDetectionLinks(state),
    detectionLinksFailured: getLinksManagementLinksProcessedDetectionLinksFailured(
      state
    ),
    detectionLinksSuccessfully: getLinksManagementLinksProcessedDetectionLinksSuccessfully(
      state
    ),
    relaunchEnforcementSuccessfulLinksCount: getLinksManagementRelaunchEnforcementSuccessfulLinksCount(
      state
    ),
    relaunchEnforcementErrorLinksCount: getLinksManagementRelaunchEnforcementErrorLinksCount(
      state
    ),
  };
};

export default connect(mapStateToProps)(LinksManagementMessages);
